import React from 'react';
import { Image as ImageIcon, RefreshCw, BarChart3, Trophy } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Features = () => {
  const features = [
    {
      icon: ImageIcon,
      title: 'Picture Associations',
      description: 'Words are introduced through clear visual connections that make meaning easier to understand and remember.',
      color: '#FF7F30',
    },
    {
      icon: RefreshCw,
      title: 'Swipe Repetition',
      description: 'Each swipe shows how well a word was remembered, helping LinguPix bring it back when practice matters most.',
      color: '#4CAF50',
    },
    {
      icon: BarChart3,
      title: 'Visible Progress',
      description: 'Parents and educators can clearly track words mastered, accuracy, completed categories, and practice consistency.',
      color: '#2196F3',
    },
    {
      icon: Trophy,
      title: 'Rewards That Motivate',
      description: 'Badges, stars, streaks, and session wins help children stay engaged and want to come back.',
      color: '#FFD700',
    },
  ];

  return (
    <section id="why-it-works" className="py-8 sm:py-12 lg:py-16 px-4 sm:px-6 lg:px-8 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-left sm:text-center mb-8 sm:mb-16 space-y-4">
          <div className="inline-block px-4 py-2 bg-[#FFF3E0] rounded-full border border-[#FFE0B2]">
            <span className="text-[#FF7F30] font-semibold text-sm tracking-wide">Why LinguPix Works</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#333333] leading-[1.05] sm:leading-tight lg:leading-[1.1]">
            Built Around How
            <span className="block text-[#FF7F30]">Kids Actually Learn</span>
          </h2>
          <p className="text-lg sm:text-xl text-[#666666] max-w-3xl mx-auto leading-relaxed">
            LinguPix combines picture associations, audio, movement, and smart repetition to help children remember new words more naturally. It feels playful in the moment, but every swipe helps decide what should come back next.
          </p>
        </div>

        {/* Features grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <Card
              key={index}
              className="border-none shadow-none"
              style={{ backgroundColor: `${feature.color}20`, animationDelay: `${index * 0.1}s` }}
            >
              <CardContent className="p-6 space-y-4 flex flex-col h-full">
                <div className="shrink-0 mb-1">
                  <feature.icon size={32} style={{ color: feature.color }} />
                </div>
                <h3 className="text-xl font-bold text-[#333333]">{feature.title}</h3>
                <p className="text-[#666666] leading-relaxed flex-grow">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;